import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, Music, TrendingUp } from 'lucide-react'; 

export function PlaylistStats({
  playlist,
  currentIndex,
  isPlaying,
  totalDuration, 
  normalizationApplied,
  showNormalizationIndicator
}) {
  const [showNormalizationLocal, setShowNormalizationLocal] = useState(false);

  console.log("PlaylistStats: Received totalDuration prop:", totalDuration);

  useEffect(() => {
    if (showNormalizationIndicator && normalizationApplied > 0) {
      setShowNormalizationLocal(true);
      const timer = setTimeout(() => {
        setShowNormalizationLocal(false);
      }, 10000);
      return () => clearTimeout(timer);
    } else {
      setShowNormalizationLocal(false);
    }
  }, [showNormalizationIndicator, normalizationApplied]);

  const formatDuration = (durationInSeconds) => {
    if (typeof durationInSeconds !== 'number' || isNaN(durationInSeconds) || durationInSeconds < 0) return '0:00';
    
    const totalSeconds = Math.floor(durationInSeconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    } else {
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  };

  if (playlist.length === 0) return null;

  return (
    <div className="mt-4 pt-4 border-t border-white/10 space-y-3">
      <div className="flex items-center justify-between text-sm text-white/60">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1" title="Total tracks">
            <Music className="h-4 w-4" />
            <span>{playlist.length}</span>
          </div>
          
          <div className="flex items-center gap-1" title="Total playlist duration">
            <Clock className="h-4 w-4" />
            <span>{formatDuration(totalDuration)}</span>
          </div>
        </div>

        {currentIndex >= 0 && isPlaying && (
          <div className="text-xs text-blue-400">
            Playing {currentIndex + 1} of {playlist.length}
          </div>
        )}
      </div>
      
      <AnimatePresence>
        {showNormalizationLocal && normalizationApplied > 0 && (
          <motion.div
            initial={{ opacity: 0, height: 0, scale: 0.9 }}
            animate={{ opacity: 1, height: 'auto', scale: 1 }}
            exit={{ opacity: 0, height: 0, scale: 0.9 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="bg-gradient-to-r from-green-500/20 to-blue-500/20 backdrop-blur-sm border border-green-400/30 rounded-lg px-3 py-2"
          >
            <div className="flex items-center gap-2 text-sm">
              <TrendingUp className="h-4 w-4 text-green-400 flex-shrink-0" />
              <span className="text-green-400 font-medium">
                Volume Normalization Applied: {normalizationApplied}%
              </span>
            </div>
            <p className="text-xs text-green-300/80 mt-1">
              Tracks have been automatically balanced for consistent volume
            </p>
          </motion.div>
        )}
      </AnimatePresence>
      
      {playlist.some(song => !song.file) && (
        <p className="text-xs text-red-400">
          Some files are missing and need to be re-added
        </p>
      )}
    </div>
  );
}